import { GetClientSetting, SettingType } from '@app/api-module/control-centre-api-client';
import { CommonUtilities } from './common-utilities';

export class SettingUtilities {
    public static isSettingEnabled(clientSettings: GetClientSetting[], settingType: SettingType, siteId?: number): boolean {
        return CommonUtilities.stringEquals(SettingUtilities.getClientSetting(clientSettings, settingType, siteId), 'True');
    }

    public static getClientSetting(clientSettings: GetClientSetting[], settingType: SettingType, siteId?: number): string | null {
        const clientSetting = clientSettings.find(setting =>
            CommonUtilities.stringEquals(
                SettingUtilities.settingTypeToString(setting.settingType),
                SettingUtilities.settingTypeToString(settingType)
            )
        );

        if (!clientSetting) {
            return null;
        }

        const siteSetting = siteId ? clientSetting.sites?.find(siteSetting => siteSetting.siteId === siteId) : null;
        if (siteSetting) {
            return siteSetting.settingValue;
        }

        return clientSetting.settingValue;
    }

    private static settingTypeToString(settingType: SettingType): string {
        const stringValue = typeof settingType === 'string' ? settingType : SettingType[settingType];
        return stringValue || settingType.toString();
    }
}
